import React from 'react';
import PropTypes from 'prop-types';
import { FONT } from '../../constants/theme';

/**
 * StatusBar — the top-of-screen bar present on every screen.
 *
 * Renders three text slots (left, centre, right) against a solid
 * background colour, mimicking a Game Boy-style HUD.
 *
 * @param {object} props
 * @param {string} props.left   - Left-aligned label (e.g. venue name).
 * @param {string} props.mid    - Centre label (e.g. section title).
 * @param {string} props.right  - Right-aligned label (e.g. hearts / HP).
 * @param {string} [props.bg]   - Background colour. Defaults to primary.
 */
function StatusBar({ left, mid, right, bg }) {
  const textStyle = { fontFamily: FONT, fontSize: 7, color: '#fff8e0' };

  return (
    <div
      role="banner"
      style={{
        background: bg,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '5px 12px',
        borderBottom: '2px solid rgba(0,0,0,0.25)',
      }}
    >
      <span style={textStyle}>{left}</span>
      <span style={{ ...textStyle, color: '#f5dbb8' }}>{mid}</span>
      <span style={textStyle}>{right}</span>
    </div>
  );
}

StatusBar.propTypes = {
  left:  PropTypes.string.isRequired,
  mid:   PropTypes.string.isRequired,
  right: PropTypes.string.isRequired,
  bg:    PropTypes.string,
};

StatusBar.defaultProps = {
  bg: '#b85c38',
};

export default StatusBar;
